import { QueryObserverResult, useQuery, UseQueryOptions } from 'react-query'

import { Brand } from '../types'
import http from '../helpers/http'

export const brandKey = 'brand'

export function useBrand(configOptions?: UseQueryOptions<Brand>): QueryObserverResult<Brand> {
  const queryFn = ({ signal }: { signal?: AbortSignal }): Promise<Brand> =>
    http.get(`/brand`, { signal }).then((res) => res?.data)
  const config: UseQueryOptions<Brand> = {
    queryKey: [brandKey],
    queryFn,
    staleTime: Infinity,
    ...configOptions,
  }

  return useQuery(config)
}
